import "./Header.css"



const Header = () => { 
    return(
        <header className="HomeHeader">
        <h2></h2>
        <h1>
            <span>"</span> Unispy Blog <span>"</span>
        </h1>
        <p>The Place Where You can Read & Write Informative<br />Blogs Share Your Knowledge with World with UNISPY.</p>
    </header>
    );
  
}
 
export default Header;
